import React from "react";
import PropTypes from "prop-types";
import styles from "./NumberInput.module.css";

/**
 * Interactive component. An input item that allows a user to input a number within a given range.
 * The minimum input value is 1.
 */
export function NumberInput({ maximum, inputLabel, value, setValue }) {
  return (
    <div className={styles.container}>
      <label htmlFor={inputLabel}>{inputLabel}</label>
      <input
        name={inputLabel}
        type="number"
        max={maximum}
        min="1"
        value={value + 1}
        onFocus={(e) => e.target.select()} // auto-select on focus
        onClick={(e) => e.target.select()} // also select on click
        onChange={(e) => {
          const newVal =
            e.target.value === "" ? "" : Number(e.target.value) - 1; // shift back to 0-based

          if (
            e.target.value === "" ||
            (!(newVal >= maximum) && !(newVal < 0))
          ) {
            setValue(newVal);
          }
        }}
      />
    </div>
  );
}

NumberInput.propTypes = {
  /**
   * The maximum input value.
   */
  maximum: PropTypes.number,
  /**
   * The label text.
   */
  inputLabel: PropTypes.string,
  /**
   * The current input value.
   */
  value: PropTypes.number,
  /**
   * Function that sets the value of the input.
   * Takes the event as a parameter.
   */
  setValue: PropTypes.func,
};
